module.exports = __webpack_public_path__ + "static/media/10.0720b845.svg";